module.exports = __webpack_public_path__ + "static/media/emptyStreet.0138c5a6.svg";